/**
 * Search params for deep-linking into the SIM Cards list, filtered to one card.
 *
 * There is no `/sim-cards/$simCardId` detail page, so "open this SIM card" means
 * "open the list filtered to its ICCID" (OTO-157).
 *
 * The route's `validateSearch` returns all six keys, which makes every one of
 * them **required** on the link — a partial object does not typecheck, and the
 * `(prev) => …` updater form does not narrow either, because `prev` is the union
 * of every route's search params. So the full shape is spelled out here once
 * rather than at each call site.
 */
export function simCardsSearchForIccid(iccid: string): {
  page: number;
  pageSize: number;
  sortBy: string | undefined;
  sortDirection: "asc" | "desc";
  globalFilter: string;
  columnFilters: Record<string, unknown>;
} {
  return {
    page: 1,
    pageSize: 20,
    sortBy: undefined,
    sortDirection: "asc",
    globalFilter: iccid,
    columnFilters: {},
  };
}
